import type { TagJSONObject } from '@ikegps/core-api';
import { computed, makeObservable } from 'mobx';
import { sort as timSort } from 'timsort';
import { Services } from '../services';

function tagSort(summaryA: TagJSONObject, summaryB: TagJSONObject): number {
	if (summaryA.updatedAt < summaryB.updatedAt) {
		return 1;
	} else if (summaryA.updatedAt > summaryB.updatedAt) {
		return -1;
	}

	return 0;
}

export class TagStore {
	private static FETCH_TIME = 60 * 1000;
	private lastFetch: number = null;

	constructor() {
		makeObservable(this);
	}

	get fetched(): boolean {
		const rest = Services.Department.rest;
		return rest.tags.hasFetched;
	}

	async fetch(id: string): Promise<TagJSONObject | null> {
		const rest = Services.Department.rest;
		await rest.tags.fetch();
		return this.get(id);
	}

	get(id: string): TagJSONObject | null {
		if (id == null) {
			return null;
		}

		const rest = Services.Department.rest;
		if (this.lastFetch == null || this.lastFetch + TagStore.FETCH_TIME < Date.now()) {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			this.refresh();
		}

		let tag = rest.tags.find('objectId', id);

		// Old tags have different 'objectId' and 'uuid' values
		if (tag == null) {
			tag = rest.tags.find('uuid', id);
		}

		return tag;
	}

	@computed get all(): TagJSONObject[] {
		if (Services.Department.current == null) {
			return null;
		}

		const tags = Services.Department.rest.tags.value;
		if (tags == null) {
			return [];
		}

		timSort(tags, tagSort);
		return tags;
	}

	refresh(): Promise<any> {
		this.lastFetch = Date.now();
		return Services.Department.rest.tags.refetch();
	}
}
